const evaluateSource = require('../lib/evaluateSource');

/**
  * @function evalute - evaluate jobUpdateReportFormAssociationsBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const formTypeIdentifier = await evaluateSource.evaluateSource(source.formTypeIdentifier, content, parentContentPath, transientContext, nativeFunctions);
  const forms = await evaluateSource.evaluateSource(source.forms, content, parentContentPath, transientContext, nativeFunctions);

  // get the current job ID
  const jobQuerySource = {
    type: 'queryEntityBehavior',
    entityName: 'Job',
    properties: ['id'],
    equals: {
      'form/id': content.id
    }
  };
  const jobRows = await evaluateSource.evaluateSource(jobQuerySource, content, parentContentPath, transientContext, nativeFunctions);
  if (!jobRows || jobRows.length === 0) {
    return undefined;
  }
  const jobID = jobRows[0].id;

  // get all report IDs associated with the current job
  const reportQuerySource = {
    type: 'queryEntityBehavior',
    entityName: 'Report',
    properties: ['id'],
    equals: {
      'job/id': jobID
    }
  };
  const reportRows = await evaluateSource.evaluateSource(reportQuerySource, content, parentContentPath, transientContext, nativeFunctions);
  if (!reportRows || reportRows.length === 0) {
    return undefined;
  }
  const reports = reportRows.map(report => report.id);

  // clear out all existing associations from job reports
  const clearAssociationsSource = {
    type: 'reportFormIndexBehavior',
    formTypeIdentifier,
    reports
  };
  await evaluateSource.evaluateSource(clearAssociationsSource, content, parentContentPath, transientContext, nativeFunctions);

  // create new associations to passed forms from job reports
  const makeAssociationsSource = {
    type: 'reportFormIndexBehavior',
    reports,
    forms
  };
  await evaluateSource.evaluateSource(makeAssociationsSource, content, parentContentPath, transientContext, nativeFunctions);
  return true;
};
module.exports = {
  evaluate
};